import BaseApiAction from "@Actions/base-api-action";

export default class GetChallenges extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: "challenges-getChallenges",
      payload: {
        ...this.addFieldIfExists('ids', this._payload.ids,),
        ...this.addFieldIfExists('unpublished_allowed', this._payload.unpublished_allowed),
        user_id: this._payload.user_id
      },
    });
  }

  onSuccess(data: any) {
    super.onSuccess(data);
  }
}
